<template>
    <div class="fullPage">
        <!-- Banner图片区域，文字覆盖在图片上方 -->
        <div class="banner-container">
            <img src="../../assets/image/banner/banner3.jpg" alt class="fullWidth"/>
            <div class="banner-text">
                <div class="banner-content">
                    <h1>{{ $t('demurrageRate.bannerTitle') }}</h1>
                    <p>{{ $t('demurrageRate.bannerDescription') }}</p>
                </div>
            </div>
        </div>

        <!-- 主要内容区 -->
        <div class="main-center main-top">
            <div class="demurrage-rate-container">
                <!-- 搜索区域 -->
                <div class="search-section">
                    <div class="search-container">
                        <el-input
                            v-model="searchKeyword"
                            :placeholder="$t('demurrageRate.searchPlaceholder')"
                            class="search-input"
                            clearable
                            @keyup.enter.native="handleSearch"
                        ></el-input>
                        <el-button
                            type="primary"
                            icon="el-icon-search"
                            class="search-btn"
                            @click="handleSearch"
                        >
                            {{ $t('demurrageRate.searchButton') }}
                        </el-button>
                    </div>
                </div>
                
                <!-- 国内文件折叠区域 -->
                <div class="section-card" v-if="filteredDomesticFiles.length > 0">
                    <el-collapse
                        v-model="domesticActiveNames"
                        @change="handleDomesticChange"
                    >
                        <el-collapse-item name="domestic">
                            <template slot="title">
                                <div class="collapse-header">
                                    <h3><i class="el-icon-location"></i> {{ $t('demurrageRate.domesticRegion') }}</h3>
                                </div>
                            </template>
                            <div class="divider-line"></div>
                            <div class="file-list">
                                <div class="file-card" v-for="(item, index) in filteredDomesticFiles" :key="index">
                                    <div class="file-card-content">
                                        <div class="file-info">
                                            <h5>
                                                <img src="../../assets/image/pdf-file-icon.jpeg" alt="PDF" class="pdf-icon"/>
                                                {{ item.name }}
                                            </h5>
                                            <div class="file-meta">
                                                <span><i class="el-icon-files"></i> {{ $t('demurrageRate.fileSize') }}{{ item.size }}</span>
                                            </div>
                                            <div class="file-meta">
                                                <span><i class="el-icon-time"></i> {{ $t('demurrageRate.publishDate') }}{{ item.publishDate }}</span>
                                            </div>
                                        </div>
                                        <el-button
                                            type="primary"
                                            class="download-btn"
                                            @click="downloadFile(item.filename)"
                                        >
                                            <i class="el-icon-download"></i>{{$t("common.downloadButton")}}
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </div>

                <!-- 国外文件折叠区域 -->
                <div class="section-card" v-if="filteredForeignFiles.length > 0">
                    <el-collapse
                        v-model="foreignActiveNames"
                        @change="handleForeignChange"
                    >
                        <el-collapse-item name="foreign">
                            <template slot="title">
                                <div class="collapse-header">
                                    <h3><i class="el-icon-location"></i> {{ $t('demurrageRate.foreignRegion') }}</h3>
                                </div>
                            </template>
                            <div class="divider-line"></div>
                            <div class="file-list">
                                <div class="file-card" v-for="(item, index) in filteredForeignFiles" :key="index">
                                    <div class="file-card-content">
                                        <div class="file-info">
                                            <h5>
                                                <img src="../../assets/image/pdf-file-icon.jpeg" alt="PDF" class="pdf-icon"/>
                                                {{ item.name }}
                                            </h5>
                                            <div class="file-meta">
                                                <span><i class="el-icon-files"></i> {{ $t('demurrageRate.fileSize') }}{{ item.size }}</span>
                                            </div>
                                            <div class="file-meta">
                                                <span><i class="el-icon-time"></i> {{ $t('demurrageRate.publishDate') }}{{ item.publishDate }}</span>
                                            </div>
                                        </div>
                                        <el-button
                                            type="primary"
                                            class="download-btn"
                                            @click="downloadFile(item.filename)"
                                        >
                                            <i class="el-icon-download"></i>{{$t("common.downloadButton")}}
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getCurrentEntity } from '@/utils/apiUtils';

export default {
    name: 'demurrageRate',
    data() {
        return {
            // 搜索关键词
            searchKeyword: '',
            // 国内折叠面板激活状态（默认展开）
            domesticActiveNames: ['domestic'],
            // 国外折叠面板激活状态（默认展开）
            foreignActiveNames: ['foreign'],
            // 国内文件列表（包含所属主体字段）
            domesticFiles: [
                { name: '钦州--Qinzhou', size: '173KB', publishDate: '2025-09-01', filename: '钦州进出口费率表.pdf', entities: ['1', '2'] },
                { name: '天津--Tianjin', size: '173KB', publishDate: '2025-09-01', filename: '天津进出口费率表.pdf', entities: ['1', '2'] },
                { name: '青岛--Qingdao', size: '173KB', publishDate: '2025-09-01', filename: '青岛进出口费率表.pdf', entities: ['1', '2'] },
                { name: '厦门--Xiamen', size: '173KB', publishDate: '2025-09-01', filename: '厦门进出口费率表.pdf', entities: ['1', '2'] },
                { name: '华南珠三角（广州南沙蛇口）--South China Pearl River Delta(Guangzhou Nansha Shekou)', size: '176KB', publishDate: '2025-09-01', filename: '华南珠三角（广州南沙蛇口）进出口费率表.pdf', entities: ['1', '2'] },
                { name: '华东（宁波上海）--East China(Ningbo and Shanghai)', size: '174KB', publishDate: '2025-09-01', filename: '华东（宁波上海）进出口费率表.pdf', entities: ['1', '2'] }
            ],
            // 国外文件列表（包含所属主体字段）
            foreignFiles: [
                { name: '海防--HAI PHONG', size: '179KB', publishDate: '2025-09-01', filename: '海防进出口费率表.pdf', entities: ['1', '2'] },
                { name: '印尼--INDONESIA', size: '173KB', publishDate: '2025-09-01', filename: '印尼进出口费率表.pdf', entities: ['1', '2'] },
                { name: '约旦--Jordan', size: '172KB', publishDate: '2025-09-01', filename: '约旦进出口费率表.pdf', entities: ['1', '2'] },
                { name: '沙特阿拉伯--Saudi Arabia', size: '173KB', publishDate: '2025-12-15', filename: '沙特阿拉伯进出口费率表.pdf', entities: ['1', '2'] },
                { name: '也门--Yemen', size: '171KB', publishDate: '2025-12-15', filename: '也门进出口费率表.pdf', entities: ['1', '2'] },
                { name: '埃及--Egypt', size: '172KB', publishDate: '2025-09-01', filename: '埃及进出口费率表.pdf', entities: ['1', '2'] },
                { name: '印度--India', size: '172KB', publishDate: '2025-09-01', filename: '印度进出口费率表.pdf', entities: ['1', '2'] },
                { name: '巴基斯坦--Pakistan', size: '173KB', publishDate: '2025-09-01', filename: '巴基斯坦进出口费率表.pdf', entities: ['1', '2'] },
                { name: '马来西亚--Malaysia', size: '172KB', publishDate: '2025-09-01', filename: '马来西亚进出口费率表.pdf', entities: ['1', '2'] },
                { name: '斯里兰卡--Sri lanka', size: '172KB', publishDate: '2025-09-01', filename: '斯里兰卡进出口费率表.pdf', entities: ['1', '2'] },
                { name: '泰国--Thailand', size: '189KB', publishDate: '2025-09-01', filename: '泰国进出口费率表.pdf', entities: ['1', '2'] },
                { name: '柬埔寨--Cambodia', size: '189KB', publishDate: '2025-09-01', filename: '柬埔寨进出口滞箱费率表.pdf', entities: ['1', '2'] },
                { name: '土耳其--Turkey', size: '189KB', publishDate: '2025-09-01', filename: '土耳其进出口滞箱费费率表.pdf', entities: ['1', '2'] }
            ]
        }
    },
    computed: {
        // 获取当前用户主体
        currentEntity() {
            return getCurrentEntity();
        },
        // 过滤后的国内文件列表（先按主体过滤，再按搜索关键词过滤）
        filteredDomesticFiles() {
            if (!this.currentEntity) {
                return [];
            }
            let files = this.domesticFiles.filter(file => {
                return file.entities && file.entities.includes(this.currentEntity);
            });
            
            // 如果有搜索关键词，进行搜索过滤
            if (this.searchKeyword && this.searchKeyword.trim()) {
                const keyword = this.searchKeyword.trim().toLowerCase();
                files = files.filter(file => {
                    // 匹配中文名或英文名（不区分大小写）
                    const name = file.name.toLowerCase();
                    return name.includes(keyword);
                });
            }
            
            return files;
        },
        // 过滤后的国外文件列表（先按主体过滤，再按搜索关键词过滤）
        filteredForeignFiles() {
            if (!this.currentEntity) {
                return [];
            }
            let files = this.foreignFiles.filter(file => {
                return file.entities && file.entities.includes(this.currentEntity);
            });
            
            // 如果有搜索关键词，进行搜索过滤
            if (this.searchKeyword && this.searchKeyword.trim()) {
                const keyword = this.searchKeyword.trim().toLowerCase();
                files = files.filter(file => {
                    // 匹配中文名或英文名（不区分大小写）
                    const name = file.name.toLowerCase();
                    return name.includes(keyword);
                });
            }
            
            return files;
        }
    },
    methods: {
        // 下载文件
        downloadFile(filename) {
            const fileUrl = `/static/demurrage/${filename}`;
            
            // 显示加载提示
            const loading = this.$loading({
                lock: false,
                text: this.$t('message.downloading') || '正在下载...',
                spinner: 'el-icon-loading',
                background: 'rgba(0,0,0,0.1)'
            });
            
            // 使用 axios 下载文件为 blob
            this.axios({
                method: 'get',
                url: fileUrl,
                responseType: 'blob',
                headers: {
                    'Accept-language': localStorage.getItem("locale")
                }
            }).then(response => {
                // 创建 blob 对象
                const blob = new Blob([response.data], { type: response.data.type || 'application/pdf' });
                
                // 创建 blob URL
                const blobUrl = window.URL.createObjectURL(blob);
                
                // 创建下载链接
                const downloadElement = document.createElement('a');
                downloadElement.href = blobUrl;
                downloadElement.download = filename; // 设置下载文件名
                downloadElement.style.display = 'none';
                
                // 添加到 DOM 并触发下载
                document.body.appendChild(downloadElement);
                downloadElement.click();

                // 清理
                document.body.removeChild(downloadElement);
                window.URL.revokeObjectURL(blobUrl); // 释放 blob URL
                
                // 延迟1秒后关闭加载提示，确保用户能看到下载中的提示
                setTimeout(() => {
                    loading.close();
                    // 显示成功提示
                    this.$message.success(`《${filename}》${this.$t('demurrageRate.downloadComplete')}`);
                }, 1000);
            }).catch(error => {
                // 延迟1秒后关闭加载提示
                setTimeout(() => {
                    loading.close();
                    // 显示错误提示
                    this.$message.error(this.$t('demurrageRate.downloadFailed') || '下载失败');
                }, 1000);
                console.error('文件下载失败:', error);
            });
        },
        // 国内折叠面板状态变化监听
        handleDomesticChange(val) {
            this.domesticActiveNames = val;
        },
        // 国外折叠面板状态变化监听
        handleForeignChange(val) {
            this.foreignActiveNames = val;
        },
        // 搜索处理
        handleSearch() {
            // 搜索逻辑在计算属性中实现，这里可以添加其他逻辑
            // 如果有搜索结果，自动展开对应的折叠面板
            if (this.filteredDomesticFiles.length > 0) {
                if (!this.domesticActiveNames.includes('domestic')) {
                    this.domesticActiveNames.push('domestic');
                }
            }
            if (this.filteredForeignFiles.length > 0) {
                if (!this.foreignActiveNames.includes('foreign')) {
                    this.foreignActiveNames.push('foreign');
                }
            }
        }
    }
}
</script>

<style scoped lang="scss">
// Banner容器，文字覆盖在图片上方
.banner-container {
    position: relative;
    width: 100%;
}

.banner-container img {
    width: 100%;
    display: block;
}

.banner-text {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.3);
}

.banner-content {
    text-align: center;
    color: #fff;
    padding: 20px;
    max-width: 1200px;
    margin: 0 auto;
    
    h1 {
        font-size: 2.5rem;
        font-weight: 600;
        margin-bottom: 15px;
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
    }
    
    p {
        font-size: 1.1rem;
        opacity: 0.95;
        text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
        line-height: 1.6;
    }
}

.demurrage-rate-container {
    padding: 20px;
    padding-top: 100px;
    //background: #fff;
    border-radius: 4px;
    //box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

/* 搜索区域样式 */
.search-section {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    padding: 20px;
    margin-bottom: 20px;
}

.search-container {
    display: flex;
    align-items: center;
    gap: 12px;
    max-width: 600px;
    margin: 0;
}

.search-input {
    flex: 1;
}

.search-btn {
    flex-shrink: 0;
    background-color: #bc1920;
    border-color: #bc1920;
}

.search-btn:hover {
    background-color: #a0151b;
    border-color: #a0151b;
}

/* 区域卡片样式 */
.section-card {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    padding: 20px;
    margin-bottom: 20px;
}

.section-card:last-child {
    margin-bottom: 0;
}

.el-collapse {
    border: none !important;
}

.el-collapse-item {
    border: none !important;
    margin-bottom: 0;
}

.el-collapse-item__header {
    background-color: transparent !important;
    padding: 18px 0 !important;
    border-radius: 0;
    box-shadow: none !important;
    font-size: 1.5rem !important;
    color: #bc1920 !important;
    font-weight: 600;
    border-bottom: none !important;
}

.el-collapse-item__header i {
    color: #bc1920 !important;
    font-size: 1.6rem !important;
    margin-right: 12px;
}

.el-collapse-item__content {
    padding: 0 !important;
    padding-top: 15px !important;
}

/* 分隔线样式 */
.divider-line {
    height: 1px;
    background-color: #e4e7ed;
    margin: 15px 0;
}

.collapse-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    
    h3 {
        font-size: 1.2rem;
        font-weight: 600;
        margin: 0;
        display: flex;
        align-items: center;
    }
}

/* 文件列表卡片 - 固定一排3个 */
.file-list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-top: 15px;
}

.file-card {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    padding: 5px 15px;
    transition: all 0.3s ease;
    border-left: 4px solid #bc1920;
    position: relative;
    min-height: 140px;
}

.file-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

.file-card-content {
    position: relative;
    height: 100%;
}

.file-info {
    flex: 1;
    min-width: 0;
    // padding-bottom: 40px;
}

.file-card h5 {
    //color: #bc1920;
    font-weight: 500;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    font-size: 15px;
}

.pdf-icon {
    width: 40px;
    height: 40px;
    margin-right: 10px;
    object-fit: contain;
    flex-shrink: 0;
}

.file-meta {
    color: #666;
    font-size: 12px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
}

.file-meta span {
    display: flex;
    align-items: center;
}

.file-meta span i {
    margin-right: 5px;
    color: #bc1920;
}

.download-btn {
    position: absolute;
    bottom: 35px;
    right: 0;
    background-color: #fff;
    color: #bc1920;
    border-color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.9rem;
    white-space: nowrap;
    padding: 8px 12px;
}

.download-btn:hover {
    background-color: #fff7fb;
    border-color: #bc1920;
    transform: scale(1.02);
}

.download-btn i {
    margin-right: 5px;
}

.copyright {
    border-top: 1px solid rgba(255, 255, 255, 0.2);
    padding-top: 20px;
    font-size: 0.9rem;
    opacity: 0.8;
    text-align: center;
}

/* 响应式适配 */
@media (max-width: 992px) {
    .file-list {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 576px) {
    .file-list {
        grid-template-columns: 1fr;
    }

    .banner-content {
        h1 {
            font-size: 1.8rem;
        }
        
        p {
            font-size: 0.95rem;
        }
    }

    .el-collapse-item__header {
        font-size: 1.1rem !important;
    }
}
</style>